import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsultationComponent } from './consultation.component';
import { SharedModule } from '../shared/shared.module';
import { ConsultationEditComponent } from './consultation-edit/consultation-edit.component';
import { ConsultationFormComponent } from './shared/consultation-form/consultation-form.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    ConsultationComponent,
    ConsultationEditComponent,
    ConsultationFormComponent
  ]
})
export class ConsultationModule { }



// WEBPACK FOOTER //
// ./src/app/consultation/consultation.module.ts